import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW8LRG.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>September 2, 2024</ClientTag>
                            <Title>Seasons Change</Title>
                            <TechniqueTitle>
                            Seasons Change ... And so should your diet!
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>As summer winds down and the vibrant colours of autumn begin to emerge, it is the perfect time to embrace the cozy, comforting elements of the season. When you think of autumn, what comes to mind? Perhaps the crisp air, cozy sweaters, or the irresistible aroma of a pumpkin spice latte?</p>
                    <p className='content'>In Eastern medicine, the transition from summer to fall is seen as a time to slow down and embrace relaxation. As days grow short and cooler, our bodies naturally shift into a mode requiring less energy. This seasonal change offers a valuable opportunity to decrease our activities, and focus on mindfulness, meditation, and practicing gratitude. Traditional Chinese Medicine (TCM) teaches us that the emotions most often associated with autumn are sadness and grief. It is no wonder that our bodies crave a little extra care and attention during this time of year. </p>
                     <p className='content'>One way to nurture your body through this transition is by aligning your diet with the season. Eating in-season foods not only enhances the nutritional value of your meals but also helps to protect against colds and flus. To maintain balance, or homeostasis, in your body, it is essential to incorporate more “warming foods” into your diet, This may mean saying goodbye to the summer staples like smoothies, yogurts, popsicles, and ice
cream, and instead welcoming hearty soups, creamy oatmeal, and spiced chai teas. </p>
                     <p className='content'>By adjusting your lifestyle to the rhythms of the season, you can create a nourishing, supportive environment for both your body and mind as your prepare for the months ahead. </p>

                  
                    <h3 className='my-5'>Fall Seasonal Foods</h3>
                    <div>
                      <p className='content'>1. Fruits: Apples, pears, cranberries, grapes, & plums </p>
                      <p className='content'>2. Vegetables: Squash, pumpkins, carrots, beets, sweet potatoes, Brussel sprouts, cabbage, cauliflower, leeks, parsnips  </p>
                      <p className='content'>3. Herbs & Spices: Sage, rosemary, thyme, cinnamon </p>
                      <p className='content'>4. Others: Mushrooms (chanterelles & oyster), nuts (walnuts & hazelnuts), and maple syrup </p>
                      <p className='content'>* Speak with your Naturopathic Doctor to learn more about which foods and lifestyle changes to incorporate! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW8" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);